// src/features/editor/lib/uploadKinescopeVideo.ts
import { uploadVideoWithTus } from '@/api/uploadVideoWithTus'
import type { CreateVideoResponse } from '@/features/editor/videosApi'

// Шаги 1+2 контракта: инициализация в нашем API → TUS-заливка в Kinescope.
// Возвращает Kinescope video ID для записи в videoId/videoIdEn блока.
export async function uploadKinescopeVideo(params: {
  file: File
  title: string
  createVideo: (arg: {
    filesize: number
    title: string
    filename: string
  }) => Promise<CreateVideoResponse>
  onProgress?: (percent: number) => void
  signal?: AbortSignal
}): Promise<string> {
  const { file, title, createVideo, onProgress, signal } = params

  const { id, endpoint } = await createVideo({
    filesize: file.size,
    title,
    filename: file.name,
  })

  // Блок удалили, пока ждали ответ: сам ролик в Kinescope уже создан, но заливать в него
  // незачем.
  if (signal?.aborted) throw new DOMException('Upload aborted', 'AbortError')

  await uploadVideoWithTus({
    file,
    endpoint,
    onProgress: onProgress ? (p) => onProgress(p.percent) : undefined,
    signal,
  })

  return id
}
